import { render, staticRenderFns } from "./IconComponentWVcard.vue?vue&type=template&id=75d7a973&"
import script from "./IconComponentWVcard.vue?vue&type=script&lang=js&"
export * from "./IconComponentWVcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports